var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6083 20.9324C19.6083 21.2155 19.4958 21.4871 19.2956 21.6873C19.0954 21.8875 18.8239 22 18.5407 22H1.4592C1.17605 22 0.904506 21.8875 0.704293 21.6873C0.50408 21.4871 0.391602 21.2155 0.391602 20.9324V7.71198C0.391489 7.54929 0.428559 7.38873 0.49998 7.24256C0.5714 7.09639 0.675283 6.96847 0.803693 6.86858L9.34445 0.224936C9.53186 0.0791509 9.76252 0 9.99995 0C10.2374 0 10.4681 0.0791509 10.6555 0.224936L19.1962 6.86858C19.3246 6.96847 19.4285 7.09639 19.4999 7.24256C19.5714 7.38873 19.6084 7.54929 19.6083 7.71198V20.9324ZM17.4731 19.8648V8.23297L9.99995 2.42098L2.52679 8.23297V19.8648H17.4731Z",
    fill: "#007ACC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.2738c18a02fb4fa36d3acc40e5215771.svg";
export { ForwardRef as ReactComponent };